import styled, { css, keyframes } from 'styled-components';
import { APPS_PHONE_MEDIA } from '../../apps.constants';
import { BUILD_REVEAL_MS } from './builderWorkspace.constants';

export const CanvasRoot = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.level4};
  flex: 1 1 auto;
  min-height: 0;
  min-width: 0;
  padding: ${({ theme }) => `${theme.spacing.level4} ${theme.spacing.level5} ${theme.spacing.level5}`};
  background: ${({ theme }) => theme.colors.surface};

  ${APPS_PHONE_MEDIA} {
    padding: ${({ theme }) => theme.spacing.level4};
  }
`;

export const CanvasTools = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.level2};
  margin-left: auto;
`;

export const CanvasBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.level3};
  min-height: 36px;
  flex: 0 0 auto;
`;

export const ChatToggleAnchor = styled.div`
  position: relative;
  display: flex;
`;

export const Stage = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
`;

const fadeAway = keyframes`
  from { opacity: 1; transform: scale(1); }
  to { opacity: 0; transform: scale(0.98); }
`;

export const Cover = styled.div<{ readonly $over: boolean; readonly $leaving: boolean }>`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  background: ${({ theme }) => theme.colors.surface};
  ${({ $over }) =>
    $over &&
    css`
      position: absolute;
      inset: 0;
      z-index: 2;
    `}
  ${({ $leaving }) =>
    $leaving &&
    css`
      pointer-events: none;
      animation: ${fadeAway} ${BUILD_REVEAL_MS}ms ease-in forwards;
    `}

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;
